type HeroSecProps = { title: string }

export const HeroSecData: HeroSecProps[] = [
  { title: 'exclusive designs' },
  { title: 'decor elements' },
  { title: 'textline and interior' },
  { title: 'enlightenment' },
  { title: 'modern living rooms' },
  { title: 'exclusive designs' },
]
